import { StorageInterface } from '../stores/childNavStores';

/**
 * Web storage adapter backed by window.localStorage.
 * Used by ChildNavWeb so the store layer has a concrete persistence mechanism.
 */
export class LocalStorageAdapter implements StorageInterface {
  async getItem(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  async setItem(key: string, value: string): Promise<void> {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Ignore quota or security errors
    }
  }

  async removeItem(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  }
}
